import React from "react";
import SubscriptionTemporaryDiscountBadge from "./SubscriptionTemporaryDiscountBadge";
import SubscriptionCardLabel from "../SubscriptionCardLabel/SubscriptionCardLabel";

const SubscriptionCardContent = (props) => {
  const {
    cost,
    ticketsCount,
    discount,
    label,
    isDoublePrize,
    temporaryDiscountValue,
  } = props;

  const hasBasicDiscount =
    discount && discount.status === true && discount.value > 0;
  const hasTemporaryDiscount =
    temporaryDiscountValue && temporaryDiscountValue > 0 ? true : false;
  const discountedCost = hasTemporaryDiscount
    ? cost - temporaryDiscountValue
    : cost;

  const ticketsData = (
    <div className="subscription-card-body__header-price-row-inner">
      {/* <span>{ticketsCount / 3} tickets</span> */}
      <span>{ticketsCount} tickets</span>
    </div>
  );

  const parseTotalCost = () => {
    let costValue = cost;
    if (String(costValue).includes(".")) {
      return `£${costValue.toFixed(2)}`;
    }
    return `£${costValue}`;
  };

  const parseDiscountCost = () => {
    let costValue;
    if (discount && discount.status === true && cost !== 10) {
      costValue = cost * discount.value;
    } else {
      costValue = cost;
    }
    if (String(costValue).includes(".")) {
      return `£${costValue.toFixed(2)}`;
    }
    return `£${costValue}`;
  };

  const getTicketPrice = () => {
    if (ticketsCount) {
      let costValue =
        discount && discount.status === true && cost !== 10
          ? cost * discount.value
          : cost;
      const tiketCost = (discountedCost * 100) / ticketsCount;      
      if (isDoublePrize) {
        return Math.round((tiketCost - 0.1) / 2);
      } else {
        return Math.floor(tiketCost);
      }
    } else return null;
  };

  return (
    <div className="subscription-card-body__header">
      {label ? (
        <span className="subscription-card-body__header-label">{label}</span>
      ) : null}
      {isDoublePrize ? <SubscriptionCardLabel ticketsAmount={ticketsCount}/> : null}
      <div className="subscription-card-body__header-details">
        <div className="subscription-card-body__header-price-row">
          {/* {discount && discount.status === true ? (
            <p className="subscription-card-body__header-crossed-out-cost">{parseTotalCost()}</p>
          ) : undefined}
          {discount && discount.status === true ? (
            <p>{parseDiscountCost()}</p>
          ) : (
            <p>{parseTotalCost()}</p>
          )}
          <span>/month</span> */}
          {hasTemporaryDiscount ? (
            <div className="subscription-offer__price-wrapper">
              <p className="subscription-offer__price-discount">£{cost}</p>
              <p className="subscription-offer__price">
                £{discountedCost} <span>/month</span>
              </p>
            </div>
          ) : (
            <p className="subscription-offer__price">
              £{cost}
              <span>/month</span>
            </p>
          )}
          <span className="ticket-price">
            Only {getTicketPrice()}p per ticket
          </span>
        </div>

        {ticketsData}
      </div>
      <SubscriptionTemporaryDiscountBadge
        hasDiscount={hasBasicDiscount}
        discount={discount}
        hasTemporaryDiscount={hasTemporaryDiscount}
        temporaryDiscount={temporaryDiscountValue}
      />
    </div>
  );
};

export default SubscriptionCardContent;
